import { UpgradePopupConfig } from '../types';

export const UPGRADE_POPUP_CONFIGS: Record<string, UpgradePopupConfig> = {
  ai_tokens_trial: {
    variant: 'ai_tokens_trial',
    purchaseType: 'subscription',
    image: '/static/i/upgrade_plan/upgrade-plan-popup-v2.webp',
    titleKey: 'trialPopup.upgradePopup.aiTokensTrial.title',
    descriptionKey: 'trialPopup.upgradePopup.aiTokensTrial.description',
    features: [],
    showTokensCount: true,
  },
  ai_tokens_subscription: {
    variant: 'ai_tokens_subscription',
    purchaseType: 'ai_tokens',
    image: '/static/i/upgrade_plan/upgrade-plan-popup-v1.webp',
    titleKey: 'trialPopup.upgradePopup.aiTokensSubscription.title',
    descriptionKey: 'trialPopup.upgradePopup.aiTokensSubscription.description',
    features: [],
    showTokensCount: true,
  },
  download_trial: {
    variant: 'download_trial',
    purchaseType: 'subscription',
    image: '/static/i/upgrade_plan/upgrade-plan-popup-v2.webp',
    titleKey: 'trialPopup.upgradePopup.downloadTrial.title',
    descriptionKey: 'trialPopup.upgradePopup.downloadTrial.description',
    features: [
      'trialPopup.upgradePopup.features.unlimitedPptxDownloads',
      'trialPopup.upgradePopup.features.upTo50Slides',
      'trialPopup.upgradePopup.features.moreImageInfographics',
      'trialPopup.upgradePopup.features.uploadOwnLogo',
      'trialPopup.upgradePopup.features.premiumStyles',
    ],
    showNotReadyText: true,
  },
  styles_trial: {
    variant: 'styles_trial',
    purchaseType: 'subscription',
    image: '/static/i/upgrade_plan/upgrade-plan-popup-v2.webp',
    titleKey: 'trialPopup.upgradePopup.stylesTrial.title',
    descriptionKey: 'trialPopup.upgradePopup.stylesTrial.description',
    features: [
      'trialPopup.upgradePopup.features.premiumThemes',
      'trialPopup.upgradePopup.features.unlimitedPptxDownloads',
      'trialPopup.upgradePopup.features.upTo50Slides',
      'trialPopup.upgradePopup.features.aiImageInfographic',
      'trialPopup.upgradePopup.features.uploadOwnLogo',
    ],
  },
  logo_trial: {
    variant: 'logo_trial',
    purchaseType: 'subscription',
    image: '/static/i/upgrade_plan/upgrade-plan-popup-v2.webp',
    titleKey: 'trialPopup.upgradePopup.logoTrial.title',
    descriptionKey: 'trialPopup.upgradePopup.logoTrial.description',
    features: [
      'trialPopup.upgradePopup.features.uploadUseOwnLogo',
      'trialPopup.upgradePopup.features.premiumThemes',
      'trialPopup.upgradePopup.features.unlimitedPptxDownloads',
      'trialPopup.upgradePopup.features.upTo50Slides',
      'trialPopup.upgradePopup.features.aiImageInfographic',
    ],
  },
  sharing_pin_trial: {
    variant: 'sharing_pin_trial',
    purchaseType: 'subscription',
    image: '/static/i/upgrade_plan/upgrade-plan-popup-v2.webp',
    titleKey: 'trialPopup.upgradePopup.sharingPinTrial.title',
    descriptionKey: 'trialPopup.upgradePopup.sharingPinTrial.description',
    features: [
      'trialPopup.upgradePopup.features.unlimitedPptxDownloads',
      'trialPopup.upgradePopup.features.upTo50Slides',
      'trialPopup.upgradePopup.features.premiumStylesCustomLogo',
      'trialPopup.upgradePopup.features.aiImageInfographic',
    ],
  },
  large_draft_trial: {
    variant: 'large_draft_trial',
    purchaseType: 'subscription',
    image: '/static/i/upgrade_plan/upgrade-plan-popup-v2.webp',
    titleKey: 'trialPopup.upgradePopup.largeDraftTrial.title',
    descriptionKey: 'trialPopup.upgradePopup.largeDraftTrial.description',
    features: [
      'trialPopup.upgradePopup.features.uploadDrafts50Slides',
      'trialPopup.upgradePopup.features.unlimitedPptxDownloads',
      'trialPopup.upgradePopup.features.premiumStylesCustomLogo',
      'trialPopup.upgradePopup.features.aiImageInfographic',
    ],
  },
  fallback: {
    variant: 'fallback',
    purchaseType: 'subscription',
    image: '/static/i/upgrade_plan/upgrade-plan-popup-v2.webp',
    titleKey: 'trialPopup.upgradePopup.fallback.title',
    descriptionKey: 'trialPopup.upgradePopup.fallback.description',
    features: [
      'trialPopup.upgradePopup.features.unlimitedPptxDownloads',
      'trialPopup.upgradePopup.features.upTo50Slides',
      'trialPopup.upgradePopup.features.premiumStylesCustomLogo',
      'trialPopup.upgradePopup.features.aiImageInfographic',
    ],
  },
};

export const POPUP_VARIANT_MAP: Record<string, keyof typeof UPGRADE_POPUP_CONFIGS> = {
  download_trial_popup: 'download_trial',
  download_expired_popup: 'fallback',
  canvas_download_popup: 'download_trial',
  logo_trial_popup: 'logo_trial',
  style_trial_popup: 'styles_trial',
  sharing_pin_trial_popup: 'sharing_pin_trial',
  ai_tokens_trial_popup: 'ai_tokens_trial',
  ai_tokens_subscription_popup: 'ai_tokens_subscription',
};
